import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { SiteChrome } from './components/SiteChrome'
import { SiteContentProvider, useSiteContent } from './context/SiteContentContext'
import { normalizePath } from './lib/route'
import { HomePage } from './pages/HomePage'
import { ClassPage, NewsArchivePage, NewsDetailPage, StaticPage, SearchPage, NotFoundPage } from './pages/DynamicPages'

function ScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname, location.search])

  return null
}

function RouteView() {
  const location = useLocation()
  const { findPage, classFromPath, newsFromPath } = useSiteContent()
  const normalizedPath = normalizePath(location.pathname)

  if (normalizedPath === '/') {
    return <HomePage />
  }

  if (normalizedPath === '/nyheder' || normalizedPath === '/nyheder-side' || normalizedPath === '/category/nyheder' || normalizedPath === '/nyheder-page-2' || normalizedPath === '/nyheder-side/page/2' || normalizedPath === '/category/nyheder/page/2') {
    return <NewsArchivePage pageIndex={normalizedPath.includes('page/2') ? 2 : 1} />
  }

  const classEntry = classFromPath(normalizedPath)
  if (classEntry) {
    return <ClassPage />
  }

  const pageEntry = findPage(normalizedPath.replace(/^\//, ''))
  if (pageEntry || normalizedPath.startsWith('/gymnastik-26-27') || normalizedPath.startsWith('/gymnastik-25-26') || normalizedPath.startsWith('/svomning-26-27') || normalizedPath.startsWith('/svomning-25-26') || normalizedPath === '/soeg') {
    return <StaticPage />
  }

  const newsEntry = newsFromPath(normalizedPath)
  if (newsEntry) {
    return <NewsDetailPage item={newsEntry} />
  }

  return <NotFoundPage />
}

function App() {
  return (
    <HelmetProvider>
      <SiteContentProvider>
        <Helmet>
          <html lang="da-DK" />
        </Helmet>
        <SiteChrome>
          <ScrollToTop />
          <RouteView />
        </SiteChrome>
      </SiteContentProvider>
    </HelmetProvider>
  )
}

export default App
